import Marquee3k from 'marquee3000';

jQuery(function ($) {
    const $static = $('.logos-static');
    const $marquee = $('.logos-marquee');
    const $sliderStatic = $static.find('.slider-logos');

    if (!$marquee.hasClass('is-init')) {
        Marquee3k.init();
    }

    function updateView() {
        const staticWidth = $sliderStatic[0].scrollWidth;
        const containerWidth = $static.outerWidth();

        let useMarquee = staticWidth > containerWidth;

        $static.toggleClass('show', !useMarquee);
        $marquee.toggleClass('show', useMarquee);
    }

    updateView();

    $(window).on('resize', function () {
        updateView();
    });
});